// 全量包,包括所有平台
import Native from "./core/index";
import { ZZAdapter, ZLJAdapter, WechatAdapter, WechatMPAdapter, QQAdapter } from "./plugins/index";
import QQMPAdapter from "./plugins/external/QQMPAdapter";
import BaiduMPAdapter from "./plugins/external/BaiduMPAdapter";
import KuaishouAdapter from "./plugins/external/KuaishouAdapter";
import ToutiaoAdapter from "./plugins/external/ToutiaoAdapter";
import ZZHunterAdapter from "./plugins/external/ZZHunterAdapter";
import WubaAdapter from "./plugins/external/WubaAdapter";
import GAdapter from "./plugins/external/GAdapter";
import KrakenAdapter from "./plugins/external/KrakenAdapter";
import ZZSELLERAdapter from "./plugins/external/ZZSELLERAdapter";
import ZZYigeAdapter from "./plugins/external/ZZYigeAdapter";
import AlipayMPAdapter from "./plugins/external/AlipayMPAdapter";
import WechatWorkAdapter from "./plugins/external/WechatWorkAdapter";
Native.use(ZLJAdapter).use(ZZAdapter).use(WechatAdapter).use(WechatMPAdapter).use(QQAdapter).use(QQMPAdapter).use(BaiduMPAdapter).use(KuaishouAdapter).use(ToutiaoAdapter).use(ZZHunterAdapter).use(WubaAdapter).use(GAdapter).use(KrakenAdapter).use(ZZSELLERAdapter).use(ZZYigeAdapter).use(AlipayMPAdapter).use(WechatWorkAdapter);
var native = window.native && window.native._zz_native_ ? window.native : new Native();
window.native = native;
native.version = "6.0.11";
try {
  console.log('adapter--log version', native.version);
  console.log('adapter--log client', native.client);
} catch (error) {}
export { Native };
export default native;